import treesIllustration from '@/assets/trees.svg';
import {
  BodyLarge,
  BodyLargeMidEmphasis,
  BodyMedium,
  BodyMediumMidEmphasis,
  TitleMediumEmphasized
} from '@/design-system';
import colors from '@/theme/colors';
import { css } from '@emotion/css';

type Props = {
  district: string
  sheetCounter: number
  treeCounter: number
}

export const TreesSavedCounter: React.FC<Props> = ({ district, sheetCounter, treeCounter }) => {

  return (
    <section className={styles.container}>
      <TitleMediumEmphasized>
        Trees saved by your community
      </TitleMediumEmphasized>
      <BodyLargeMidEmphasis>
        {district} & Community
      </BodyLargeMidEmphasis>
      <img src={treesIllustration} alt="Trees" width="220" className={styles.illustration} />
      <div className={styles.counters}>
        <div className={styles.counter}>
          <BodyLargeMidEmphasis>Papers saved</BodyLargeMidEmphasis>
          <BodyMedium color={colors.slate}>{Math.round(sheetCounter).toLocaleString()}</BodyMedium>
        </div>
        <BodyMediumMidEmphasis>=</BodyMediumMidEmphasis>
        <div className={styles.counter}>
          <BodyLargeMidEmphasis>Trees saved</BodyLargeMidEmphasis>
          <BodyMedium color={colors.slate}>{Math.round(treeCounter).toLocaleString()}</BodyMedium>
        </div>
      </div>
      <div className={styles.content}>
        <BodyLarge>
          By using Peachjar, {district} and the community are helping reduce paper waste and saving
          trees all over the world.
        </BodyLarge>
      </div>
    </section>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 32px;
  `,
  illustration: css`
    margin: auto;
  `,
  counters: css`
    margin: auto;
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  counter: css`
    display: flex;
    flex-direction: column;
    text-align: center;
  `,
  content: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 24px;
    padding-top: 16px;
  `
};
